import bg from '../assets/pattern.png';
import * as React from 'react'
import { SubmitHandler, useForm } from 'react-hook-form';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { socket } from '../fetchoptions';

type Inputs = {
	roomId: string,
};

export default function JoinRoom () {
	let { profile } = useSelector((state: RootState) => state.user);
	// const dispatch = useDispatch();
	const { register, handleSubmit, formState: { errors }, reset } = useForm<Inputs>();
	const [message, setMessage] = React.useState(<></>);

	React.useEffect(() => {
		socket.on("message", (message) => {
			if (message.notExist)
			{
				setMessage(<span className='text-red-400'>No active room match this Id</span>)

			} else if (message.memberAlready)
			{
				setMessage(<span className='text-red-400'>You are a member already, check your rooms</span>)
			}
		})
	}, [])
	const onSubmit: SubmitHandler<Inputs> = data => {
		socket.emit('join-room', { user: profile, roomId: data.roomId })
		reset();
		// dispatch(setL)
	};
	return (
		<>
			<img src={bg} alt="Background" className='h-52 w-full object-cover' />
			<h3 className='text-center text-xl mt-4 font-serif'>Join Room</h3>
			<form onSubmit={handleSubmit(onSubmit)} className='px-4 py-6 text-sm my-4 border-t dark:border-gray-600'>
				<div className="flex">
					<div className='w-full mb-4'>
						<small>{message}</small> <br />
						<label >Room Id</label>
						<input {...register("roomId", { required: true })} className=' p-2 border w-full rounded outline-none dark:bg-slate-600 dark:border-slate-500' />
						{errors.roomId && <small className='text-red-400'>Room Id field is required</small>}
					</div>
				</div>
				<Button onClick={handleSubmit(onSubmit)} size='small' className='float-right' variant='contained'>Join</Button>
			</form>
		</>
	)
}
